<template>
  <section class="cancellation-requests-list-view">
    <app-header icon="ban" title="Solicitações de Cancelamento"></app-header>

    <div class="card">
      <div class="card-head">
        <div class="row mt-4">
          <div class="col-3 col-lg-3 col-md-3 col-sm-3 card-select">
            <div class="card-select-title">Advogado</div>

            <app-input
              v-model="searchTerm"
              placeholder="Informe o nome do advogado(a)"
              icon="search"
              type="is-primary"
            >
            </app-input>
          </div>

          <div class="col-3 col-lg-3 col-md-3 col-sm-3 card-select">
            <div class="card-select-title">Situação</div>
            <b-field>
              <b-select
                v-model="searchStatus"
                placeholder="Selecione..."
                expanded
              >
                <b-select-option :value="0">Todos</b-select-option>
                <b-select-option :value="1">Revertidas</b-select-option>
                <b-select-option :value="2">Perdidas</b-select-option>
                <b-select-option :value="3">Em atraso</b-select-option>
              </b-select>
            </b-field>
          </div>

          <div class="col-3 col-lg-3 col-md-3 col-sm-3 card-select">
            <div class="card-select-title">Solicitadas entre as datas</div>

            <b-field>
              <b-datepicker
                placeholder="Selecionar..."
                v-model="searchDates"
                range
              >
              </b-datepicker>
            </b-field>
          </div>

          <div class="col-2 col-lg-2 col-md-2 col-sm-2 mt-4">
            <b-tooltip label="Limpar filtros">
              <b-button
                @click="clearFilters"
                type="is-primary"
                icon-right="recycle"
              ></b-button>
            </b-tooltip>
          </div>
        </div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-12">
            <b-table
              :data="data"
              :total="total"
              :per-page="perPage"
              :loading.sync="isLoading"
              :current-page.sync="page"
              id="table-cancellation-requests"
              aria-page-label="Página"
              aria-next-label="Próxima Página"
              aria-current-label="Página Atual"
              aria-previous-label="Página Anterior"
            >
              <b-table-column v-slot="props" field="name" label="Nome">
                <p>{{ props.row.lawyer.name }}</p>
              </b-table-column>

              <b-table-column v-slot="props" field="email" label="E-mail">
                <p>{{ props.row.lawyer.email }}</p>
              </b-table-column>

              <b-table-column v-slot="props" field="cellphone" label="Celular">
                {{
                  props.row.lawyer.cellphone
                    | mask(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
                }}
              </b-table-column>

              <b-table-column
                v-slot="props"
                field="type"
                label="Tipo de solicitação"
              >
                {{ props.row.type.label }}
              </b-table-column>

              <b-table-column v-slot="props" field="situation" label="Situação">
                <div style="display: flex; align-items: center; gap: 5px">
                  <p v-if="props.row.reversed === null">Aguardando ação</p>
                  <p v-else>
                    {{ props.row.reversed ? "Revertido" : "Perdido" }}
                  </p>

                  <b-tooltip
                    style="cursor: pointer"
                    v-if="
                      props.row.need_attention && props.row.reversed == null
                    "
                    label="Solicitação há mais de 2 dias sem ação"
                  >
                    <b-icon
                      icon="exclamation-circle"
                      color="red"
                      size="h3"
                    ></b-icon>
                  </b-tooltip>
                </div>
              </b-table-column>

              <b-table-column
                v-slot="props"
                field="created_at"
                label="Criado em"
              >
                <p>{{ props.row.created_at }}</p>
              </b-table-column>

              <b-table-column
                v-slot="props"
                field="updated_at"
                label="Atualizado em"
              >
                <p>{{ props.row.updated_at }}</p>
              </b-table-column>

              <b-table-column v-slot="props" label="Opções" width="110">
                <b-tooltip label="Visualizar" class="m-1">
                  <b-button
                    @click="onCancellationRequestClick(props.row)"
                    type="is-dark"
                    size="is-small"
                    icon-right="eye"
                    :disabled="props.row.reversed !== null"
                  />
                </b-tooltip>
              </b-table-column>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>Nenhum registro encontrado.</p>
                  </div>
                </section>
              </template>

              <template #footer v-if="total > 0" class="totais">
                <div class="row align-middle text-center">
                  <div
                    class="col-5 col-lg-5 col-md-5 col-sm-3 ptext text-right"
                  >
                    Exibindo {{ rows }} de {{ total }}
                  </div>

                  <div class="col-auto text-center">
                    <b-pagination
                      aria-controls="table-cancellation-requests"
                      v-model="page"
                      :per-page="perPage"
                      :total-rows="total"
                      first-number
                      last-number
                    >
                    </b-pagination>
                  </div>

                  <div class="col-auto text-center">
                    <b-select
                      class="pselect"
                      v-model="perPage"
                      style="margin-left: 10px"
                    >
                      <b-select-option
                        v-for="i in perPageOptions"
                        :key="i"
                        :value="i"
                      >
                        <b>{{ i }}</b>
                      </b-select-option>
                    </b-select>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CancellationRequestService from "@/services/cancellation-request.service";
import CancellationRequest from "../../modals/CancellationRequest.vue";
import { debounce } from "lodash";
import moment from "moment";

export default {
  data: () => ({
    data: [],
    page: 1,
    total: 0,
    perPage: 10,
    isLoading: false,
    searchTerm: null,
    searchStatus: 0,
    searchDates: [],
    perPageOptions: [10, 20, 40, 80],
  }),
  watch: {
    page() {
      this.reloadCancellationRequests();
    },
    perPage() {
      this.reloadCancellationRequests(1);
    },
    searchStatus() {
      this.reloadCancellationRequests(1);
    },
    searchDates() {
      this.reloadCancellationRequests(1);
    },
    searchTerm: debounce(function () {
      this.reloadCancellationRequests(1);
    }, 600),
  },
  computed: {
    rows() {
      return this.data.length;
    },
  },
  methods: {
    getCancellationRequests() {
      this.isLoading = true;

      const params = {
        page: this.page,
        per_page: this.perPage,
      };

      if (this.searchTerm) {
        params["filter[where_lawyer_name]"] = this.searchTerm;
      }

      if (this.searchStatus) {
        params["filter[where_status]"] = this.searchStatus;
      }

      if (this.searchDates.length === 2) {
        const [start, end] = this.searchDates;
        const startDate = moment(start).format("YYYY-MM-DD");
        const endDate = moment(end).format("YYYY-MM-DD");

        params["filter[where_between_dates]"] = `${startDate},${endDate}`;
      }

      CancellationRequestService.get(params)
        .then(({ data }) => {
          const { total, data: items, current_page } = data;

          this.total = total;
          this.data = items;
          this.page = current_page;
        })
        .catch(() => {
          this.$buefy.snackbar.open(
            "Erro ao carregar solicitações de cancelamento.",
          );
        })
        .finally(() => (this.isLoading = false));
    },
    onCancellationRequestClick(cancellation_request) {
      this.$buefy.modal.open({
        parent: this,
        component: CancellationRequest,
        hasModalCard: true,
        trapFocus: true,
        canCancel: true,
        props: {
          cancellation_request,
        },
        events: {
          close: (reload) => {
            reload && this.getCancellationRequests();
          },
        },
      });
    },
    reloadCancellationRequests(page = null) {
      if (page !== null) this.page = page;
      this.getCancellationRequests();
    },
    clearFilters() {
      this.searchDates = [];
      this.searchStatus = 0;
      this.searchTerm = null;
      this.reloadCancellationRequests(1);
    },
  },
  beforeMount() {
    this.getCancellationRequests();
  },
};
</script>
